/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AiSuggestionSource = {
    Regular: 'regular',
    ShadowDecision: 'shadow_decision'
} as const;
export type AiSuggestionSource = typeof AiSuggestionSource[keyof typeof AiSuggestionSource];


export function AiSuggestionSourceFromJSON(json: any): AiSuggestionSource {
    return AiSuggestionSourceFromJSONTyped(json, false);
}

export function AiSuggestionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiSuggestionSource {
    return json as AiSuggestionSource;
}

export function AiSuggestionSourceToJSON(value?: AiSuggestionSource | null): any {
    return value as any;
}

